// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 265 ? "ed3608b8" : chunkId) + "." + {"265":"48afbda4bc0786fb","296":"cb9762ef48293116"}[chunkId] + ".js";
};